import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Button,
  ThemeProvider,
  lightTheme
} from '@rodeo-dev/legos'
import Dialog from '../../../common/layout/dialog/dialog.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import DialogPdfPreviewHeader from './dialog_pdf_preview_header'
import DialogPdfPreviewBody from './dialog_pdf_preview_body'
import DialogPdfPreviewFooter from './dialog_pdf_preview_footer'
import IntlMessage from '../../common/intl/intl_message.jsx'
import Loader from '../../common/loader/loader.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class DialogPdfPreview extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      pdfUrl: ''
    }

    this._references = {
      loader: React.createRef()
    }
  }

  static get propTypes () {
    return {
      title: PropTypes.string.isRequired,
      onClickNext: PropTypes.func
    }
  }

  show (pdfUrl) {
    if (pdfUrl) {
      FabButtonManager.setVisible(false)
      this.setState({ active: true, pdfUrl })
      this._references.loader.current.makeActive()
    }
  }

  hide = () => {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      pdfUrl: ''
    })
  };

  handleStopLoader = () => {
    this._references.loader.current.makeInActive()
  }

  render () {
    const { title, onClickNext } = this.props
    const { active, pdfUrl } = this.state
    const { hide, handleStopLoader } = this
    return (
      <ThemeProvider theme={lightTheme}>
        <Dialog
          active={active}
          onClose={hide}
          type='medium'
          className='dialog-invoiceaddress'
        >
          <DialogPdfPreviewHeader>
            <h2>{title}</h2>
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={hide}
            />
          </DialogPdfPreviewHeader>
          <DialogPdfPreviewBody>
            <Loader ref={this._references.loader} />
            <iframe src={pdfUrl} width='100%' height='100%' onLoad={handleStopLoader} />
          </DialogPdfPreviewBody>
          <DialogPdfPreviewFooter>
            <Button color='primary' onClick={onClickNext} size='small'>
              <IntlMessage ident='common.common.nextStepButton' />
            </Button>
          </DialogPdfPreviewFooter>
        </Dialog>
      </ThemeProvider>
    )
  }
}

export default DialogPdfPreview
